import { useEffect } from 'react'

import { enqueueSnackbarForRestError } from './errors'

import type { ToRestErrorMessage } from './errors'

/**
 * Shows a REST API error in a snackbar.
 *
 * @example
 * const { data, error } = useQuery(reportsQueryOptions(params))
 * useRestErrorSnackbar(error, toAgentErrorMessage)
 *
 * const { mutate } = useMutation({
 *   onError: (error: Error): void => enqueueSnackbarForRestError(error, toAgentErrorMessage),
 * })
 */
export const useRestErrorSnackbar = (error: Error | null, toMessage?: ToRestErrorMessage): void => {
  useEffect(() => {
    if (error !== null) {
      enqueueSnackbarForRestError(error, toMessage)
    }
  }, [error, toMessage])
}
